import * as jwt from 'jsonwebtoken';
import axios from 'axios';
import store from '../store';

import { history } from "../../src/index";

import * as relogin from '../actions/userdetails'
import { refreshToken } from '../api/userdetails'
import * as toasterTypes from '../constants/ActionTypes';
import * as logout from '../constants/userdetails';

export let ApiUrl;
switch (process.env.NODE_ENV) {
    case 'development':
        // ApiUrl = 'http://ec2-34-246-104-107.eu-west-1.compute.amazonaws.com/api';
        // ApiUrl = 'http://108.61.149.158:3001/api';
        // ApiUrl = 'http://108.61.149.158:3000/api';
        // ApiUrl = 'http://108.61.149.158:3003/api';//Cabinet
        // ApiUrl = 'http://192.168.214.202:8181/api';
        // ApiUrl = 'https://emcs.ega.gov.bh/api';
        ApiUrl = 'https://api.bni.alpha-meeting.com/api';//BNI
        // ApiUrl = 'https://cloud.alpha-meeting.com/api';//BNI
        // ApiUrl = 'https://api2.sicotest.alpha-meeting.com/api';
        // ApiUrl = "https://sicotest.alpha-meeting.com/api";
      //   ApiUrl = 'http://localhost:3001/api';
        break;
    case 'stagging':
        // ApiUrl = 'http://192.168.214.202:8181/api';
      //  ApiUrl = 'https://api2.sicotest.alpha-meeting.com/api';//SICO Test
      //  ApiUrl = 'https://api.matahintest.alpha-meeting.com/api';//MATAHIN Test
        ApiUrl =  'https://ajmtest.alpha-meeting.com/api' // AJM test
        break;
    case 'production':
        // ApiUrl = "https://sicotest.alpha-meeting.com/api";//SICO Test
        // ApiUrl = 'https://api2.sicotest.alpha-meeting.com/api';//SICO Test
        // ApiUrl = 'https://apiv1.sico.alpha-meeting.com/api';//SICO PROD
        ApiUrl = 'https://api.bni.alpha-meeting.com/api';//BNI Prod
        // ApiUrl = 'https://api.bnitest.alpha-meeting.com/api';//BNI Test
      //  ApiUrl = 'https://api.matahintest.alpha-meeting.com/api';//MATAHIN Test
        // ApiUrl =  'https://ajmtest.alpha-meeting.com/api' // AJM test
        break;
    default:
        // ApiUrl = 'https://api2.sicotest.alpha-meeting.com/api';
        // ApiUrl = 'https://api.matahintest.alpha-meeting.com/api';//MATAHIN Test

        // ApiUrl =  'https://ajmtest.alpha-meeting.com/api' // AJM test
        ApiUrl =  'https://api.bni.alpha-meeting.com/api' // AJM test
}

axios.defaults.baseURL = ApiUrl;
axios.defaults.timeout = 60000;
// axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('TOKEN');//eyJhbGciOiJIUzI1NiJ9.eyJpZCI6MjYsInVzZXJfaWQiOiJ6YWhpZHRlc3QyIiwidXNlcl9uYW1lIjoiemFoaWQgdGVzdCAyIiwiZW1haWxfaWQiOiJzYW50aGFuYW10c0BnbWFpbC5jb20iLCJyb2xlX2lkIjoiMiIsImN1c3RvbWVyX2lkIjoiNiIsImNvbW1pdGVfaWQiOiIifQ.z5W9wIbklRPvCWOHFt0MBqqw5i_TbbgR3ds_AfYg2mo';

exports.httpPostLogin = function (url, objBody) {
    return new Promise((resolve, reject) => {
        return axios.post(url, objBody)
            .then(function (response) {
                successResponse(response);
                resolve(response);
            })
            .catch(function (err) {
                errorResponse(err);
                reject(err);
            });
    });

}

exports.httpPostRefreshToken = function (url, objBody) {
    let config = { headers: { Authorization: 'Bearer ' + localStorage.getItem('TOKEN') } }
    return new Promise((resolve, reject) => {
        return axios.post(url, objBody, config)
            .then(function (response) {
                successResponse(response);
                resolve(response);
            })
            .catch(function (err) {
                errorResponse(err);
                reject(err);
            });
    });

}

exports.httpPostChangeRole = function (url, objBody) {
    let config = { headers: { Authorization: 'Bearer ' + localStorage.getItem('TOKEN') } }
    return new Promise((resolve, reject) => {
        return axios.post(url, objBody, config)
            .then(function (response) {
                successResponse(response);
                resolve(response);
            })
            .catch(function (err) {
                errorResponse(err);
                reject(err);
            });
    });

}

exports.httpGet = function (url) {
    if (unAuthorisedLogout()) {
        // console.log(localStorage.getItem('TOKEN'));
        let config = { headers: { Authorization: 'Bearer ' + localStorage.getItem('TOKEN') } }
        return new Promise((resolve, reject) => {
            // axios.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('TOKEN');
            return axios.get(url, config)
                .then(function (response) {
                    successResponse(response);
                    resolve(response);
                })
                .catch(function (err) {
                    errorResponse(err);
                    reject(err);
                });
        });
    }
}

exports.httpPost = function (url, objBody) {
    if (unAuthorisedLogout()) {
        let config = { headers: { Authorization: 'Bearer ' + localStorage.getItem('TOKEN') } }
        return new Promise((resolve, reject) => {
            return axios.post(url, objBody, config)
                .then(function (response) {
                    successResponse(response);
                    resolve(response);
                })
                .catch(function (err) {
                    errorResponse(err);
                    reject(err);
                });
        });
    }
}

exports.httpPut = function (url, objBody) {
    if (unAuthorisedLogout()) {
        let config = { headers: { Authorization: 'Bearer ' + localStorage.getItem('TOKEN') } }
        return new Promise((resolve, reject) => {
            return axios.put(url, objBody, config)
                .then(function (response) {
                    successResponse(response);
                    resolve(response);
                })
                .catch(function (err) {
                    errorResponse(err);
                    reject(err);
                });
        });
    }
}

exports.httpDelete = function (url, objBody) {
    if (unAuthorisedLogout()) {
        let config = { headers: { Authorization: 'Bearer ' + localStorage.getItem('TOKEN') } }
        // console.log(config)
        return new Promise((resolve, reject) => {
            return axios.delete(url, objBody, config)
                .then(function (response) {
                    successResponse(response);
                    resolve(response);
                })
                .catch(function (err) {
                    errorResponse(err);
                    reject(err);
                });
        });
    }
}

exports.httpPostFile = function (url, objBody) {
    if (unAuthorisedLogout()) {

        axios.defaults.timeout = 180000;
        axios.defaults.maxContentLength = 100000000;
        axios.defaults.maxBodyLength = 100000000;



        let config = { headers: { Authorization: 'Bearer ' + localStorage.getItem('TOKEN'), 'Content-Type': 'multipart/form-data' } }
        return new Promise((resolve, reject) => {
            // console.log(objBody)
            return axios.post(url, objBody, config)
                .then(function (response) {
                    successResponse(response);
                    resolve(response);
                })
                .catch(function (err) {
                    errorResponse(err);
                    reject(err);
                });
        });
    }
}

exports.httpGetFile = function (url) {
    if (unAuthorisedLogout()) {
        // console.log(localStorage.getItem('TOKEN'));
        let config = { headers: { Authorization: 'Bearer ' + localStorage.getItem('TOKEN') }, responseType: 'arraybuffer' }
        return new Promise((resolve, reject) => {
            // axios.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('TOKEN');
            return axios.get(url, config)
                .then(function (response) {
                    successResponse(response);
                    resolve(response);
                })
                .catch(function (err) {
                    errorResponse(err);
                    reject(err);
                });
        });
    }
}

exports.httpGetPhoto = function (url) {
    if (unAuthorisedLogout()) {
        // console.log(localStorage.getItem('TOKEN'));
        let config = { headers: { Authorization: 'Bearer ' + localStorage.getItem('TOKEN') } }
        return new Promise((resolve, reject) => {
            // axios.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('TOKEN');
            return axios.get(url, config)
                .then(function (response) {
                    // successResponse(response);
                    resolve(response);
                })
                .catch(function (err) {
                    // errorResponse(err);
                    reject(err);
                });
        });
    }
}

function successResponse(response) {
    // console.log(response)
    if (response.status == 202 && response.data && response.data.message) {
        store.dispatch({ type: toasterTypes.DISPLAY_WARNING, message: response.data.message });
    }
}

function errorResponse(err) {
    // console.log('error:', JSON.stringify(err))
    // console.log('error:', JSON.stringify(err.response.data.message))
    if (err.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);
        if (err.response && (err.response.status == 400 || err.response.status == 404)) {
            store.dispatch({ type: toasterTypes.DISPLAY_WARNING, message: err.response.data.message });
        }
        else if (err.response && err.response.status == 401)
            unAuthorisedLogout();
        else
            store.dispatch({ type: toasterTypes.DISPLAY_ERROR, message: 'System Error-API' });
    } else if (err.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        // console.log(error.request);
        store.dispatch({ type: toasterTypes.DISPLAY_ERROR, message: 'System Error-No response' });
    } else {
        // Something happened in setting up the request that triggered an Error
        // console.log('Error', error.message);
        store.dispatch({ type: toasterTypes.DISPLAY_ERROR, message: 'System Error-Internal' });
    }
    // console.log(error.config);

}

let isRefreshTokenInProgress = false;
let sessionTimeout = 'Your session has expired. Please log in again';
async function unAuthorisedLogout() {
    if (!isRefreshTokenInProgress) {
        let _token = localStorage.getItem('TOKEN');
        // console.log('local storage', _token)
        if (_token && _token.length > 0) {
            let _state = store.getState()
            // console.log('state', _state)
            // console.log('state token', _state.loginUser.token)
            // console.log((_token == _state.loginUser.token))

            try {
                var payload1 = jwt.verify(_token, '111212');
                var date1 = new Date(1000 * payload1.exp)
                var date2 = new Date()
                var minutes = Math.abs(date1 - date2) / (60 * 1000);
                // console.log('minutes', minutes)
                if (minutes < 15) {
                    isRefreshTokenInProgress = true;
                    var res = await refreshToken();
                    _token = res.data;
                    localStorage.setItem('TOKEN', _token);
                    // console.log('refreshed _token', _token)
                    var payload = jwt.decode(_token);
                    if (payload && payload.commite_id)
                        payload.committee_id = payload.commite_id
                    store.dispatch({ type: logout.USER_LOGG_IN_REQUEST_COMPLETED, payload: payload, token: _token });
                    isRefreshTokenInProgress = false;
                    _state = store.getState()
                }
            }
            catch (err) {
                // console.log('Token Verification Error:', err)
                err = JSON.parse(JSON.stringify(err))
                if (err.name == 'TokenExpiredError') {
                    localStorage.setItem('TOKEN', '');
                    store.dispatch({ type: logout.USER_LOGGED_OUT });
                    history.push('/login')
                    store.dispatch({ type: toasterTypes.DISPLAY_ERROR, message: sessionTimeout });
                    return false;
                }
            }
            if (_token == _state.loginUser.token)
                return true;
            else {
                var payload = jwt.decode(_token);
                // console.log('payload:', payload)
                if (payload && payload.commite_id)
                    payload.committee_id = payload.commite_id
                store.dispatch({ type: logout.USER_LOGG_IN_REQUEST_COMPLETED, payload: payload, token: _token });
                store.dispatch({ type: toasterTypes.DISPLAY_ERROR, message: 'Different User Login Detected' });
                return false;
            }
        }
        else {
            localStorage.setItem('TOKEN', '');
            store.dispatch({ type: logout.USER_LOGGED_OUT });
            history.push('/login')
            //store.dispatch({ type: toasterTypes.DISPLAY_ERROR, message: sessionTimeout });
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./api/config.js